import { render, staticRenderFns } from "./certificated_status.vue?vue&type=template&id=75b39776&"
import script from "./certificated_status.vue?vue&type=script&lang=js&"
export * from "./certificated_status.vue?vue&type=script&lang=js&"
import style0 from "./certificated_status.vue?vue&type=style&index=0&id=75b39776&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports